<template>
  <div :id="id" :class="doubleClickAdAppClass">
  </div>
</template>
<script>
export default {
  name: 'DoubleClickAds',
  data: function () {
    return {
      googletagWindow: null,
      id: null
    }
  },
  props: ['path', 'category', 'language', 'size', 'primaryCategory', 'articleType', 'articleID'],
  beforeCreate () {
    !this.$isEngCom && window.googletag.cmd.push(() => {
      window.googletag.destroySlots()
    })
  },
  destroyed: function () {
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots()
    })
  },
  beforeMount: function () {
    switch (this.appName) {
      case 'neweng':
        this.engAds()
        break
      default: {
        if (!this.isCategoryLoaded) {
          this.$store.dispatch('getCategories', this.$route.path.substring(1)).then(() => {
            this.runWhenMounted()
          })
        } else {
          this.runWhenMounted()
        }
      }
    }
  },
  mounted: function () {
    if (this.id) {
      window.googletag.display(this.id)
    }
  },
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    doubleClickAdAppClass: function () {
      return 'doubleClickAd-' + this.appName
    },
    getCategory: function () {
      return process.env.APP_NAME.toUpperCase().replace(/"/g, '') + '-Cat'
    },
    getLanguage: function () {
      return process.env.APP_NAME.toUpperCase().replace(/"/g, '') + '-Lan'
    },
    isCategoryLoaded: function () {
      return this.$store.getters.categoriesLoaded
    }
  },
  methods: {
    runWhenMounted: function () {
      const category = this.$store.getters.categoryBySlug(this.category)
      if (category !== null && category.hasAd) {
        this.partnerAds()
      }
    },
    partnerAds: function () {
      var mapping1 = window.googletag.sizeMapping().addSize([0, 0], []).addSize([320, 100], [315, 120]).addSize([600, 100], [600, 83]).addSize([728, 100], [728, 101]).build()
      this.googletagWindow = window.googletag.defineSlot(this.path, [[315, 120], [728, 101], [600, 83]], this.id)
        .defineSizeMapping(mapping1).setCollapseEmptyDiv(true)
        .addService(window.googletag.pubads())
        .setTargeting(this.getCategory, this.category)
        .setTargeting(this.getLanguage, this.language)
      this.id = this.googletagWindow.getSlotElementId()
      window.googletag.cmd.push(() => {
        window.googletag.pubads().enableSingleRequest()
        window.googletag.enableServices()
      })
      window.googletag.cmd.push(() => {
        window.googletag.pubads().refresh([this.googletagWindow])
      })
    },
    engAds: function () {
      this.googletagWindow = window.googletag.defineSlot(this.path, this.size)
        .addService(window.googletag.pubads())
        .setTargeting('category', this.primaryCategory.toString())
        .setTargeting('Type', this.articleType)
        .setTargeting('articleid', this.articleID.toString())
      this.id = this.googletagWindow.getSlotElementId()
      window.googletag.pubads().enableSingleRequest()
      window.googletag.enableServices()

      window.googletag.cmd.push(() => {
        window.googletag.pubads().refresh([this.googletagWindow])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

</style>
